import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import FormattedMessage from '../FormattedMessage/FormattedMessage'
import './Error.scss'

const Error = ({ message, dontShowSupport, header }) => (
  <div className="error-container" role="alert" aria-live="assertive">
    <div className="text-justify container mt-5">
      <h1>
        <FormattedMessage id={header || 'global.label.errorPage'} />
      </h1>

      {message && (
        <div className="error-message">
          <FormattedMessage id={message} />
        </div>
      )}

      {!dontShowSupport && (
        <p className="support-link-container">
          <Link className="redirect" to="/support" aria-label="Contact support for assistance">
            <FormattedMessage id="global.label.contactSupport" />
          </Link>
        </p>
      )}
    </div>
  </div>
)

Error.propTypes = {
  message: PropTypes.string,
  dontShowSupport: PropTypes.bool,
  header: PropTypes.string,
}

Error.defaultProps = {
  message: '',
  dontShowSupport: false,
  header: 'global.label.errorPage',
}

export default Error
